import LoadingIndicator from './LoadingIndicator'

export interface LoadingScreenProps {
  text?: string
  'data-testid': string
}

export default function LoadingScreen({
  text,
  'data-testid': testId
}: Readonly<LoadingScreenProps>) {
  return (
    <div className="flex flex-col gap-1 items-center justify-center text-center h-full">
      <LoadingIndicator data-testid={`${testId}-loading`} />
      {text && <div data-testid={`${testId}-loading-text`}>{text}</div>}
    </div>
  )
}
